export enum TagStartTypes {
    HCL = "```hcl",
    HTML = "```html",
}

export enum TargetTypes {
    ReactBootstrap = 'React Bootstrap',
    BootstrapCSS = 'Bootstrap CSS',
    Terraform = 'Terraform'
}